import clsx from "clsx";
import { Lock3Icon, SafeIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";

type Props = {
  label: string;
  onClick: () => void;
  isActive?: boolean;
  isLocked?: boolean;
};

export default function InventorySafeCellButton({ label, onClick, isActive, isLocked }: Props) {
  return (
    <SoundButton
      color={isActive && !isLocked ? "accent" : "gray"}
      variant={isActive && !isLocked ? "solid-gradient" : "soft"}
      className={clsx("h-[2.5rem] flex items-center justify-between px-3.5", {
        "text-white/60": !isActive && !isLocked,
        "text-white/30": !isActive && isLocked,
      })}
      onClick={onClick}
    >
      <div className="text-14 font-bold">#{label}</div>
      {isLocked ? (
        <SafeIcon size={16} className={clsx("w-4", { "text-[#84FF97]": isActive && isLocked })} />
      ) : (
        <Lock3Icon size={16} className={clsx("w-4", { "text-[#84FF97]": isActive && isLocked })} />
      )}
    </SoundButton>
  );
}
